import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/system/_auth/organizations/$organizationId/')({
    loader: ({ params }) => {
        throw redirect({
            to: '/system/organizations/$organizationId/profile',
            params,
        });
    },
});
